import { SPACING } from '@ab-core/spacing';
import styled from 'styled-components';

export const StyledLink = styled.a`
    color: inherit;
`;

export const TagTextInnerContainer = styled.div`
    display: flex;
    gap: ${SPACING.SMALL};
`;
